import { report } from '../report';

export default class Reporter {
    public debugReportOverride: undefined | typeof report;

    public report(...args: Parameters<typeof report>): void {
        (this.debugReportOverride ?? report)(...args);
    }
}
